import { Component } from 'react';

import { AccordionMultipleProps, AccordionSingleProps, Root, Trigger } from '@radix-ui/react-accordion';

import { CommonAccordionProps } from '../../types';

import { Content } from './Content';
import { Header } from './Header';
import { Item } from './Item';

type AccordionProps<T> = CommonAccordionProps & T;

function Section<
  T extends Omit<AccordionMultipleProps, 'onValueChange' | 'onChange'> | Omit<AccordionSingleProps, 'onValueChange' | 'onChange'>,
>({ index, data, value, onChange, ...props }: AccordionProps<T>) {
  const currentValue = value ?? (index !== undefined ? data[index]?.value : undefined);
  const RootComponent = Root as unknown as new () => Component<T>;

  return (
    <RootComponent value={currentValue as string} onValueChange={onChange} {...(props as unknown as T)}>
      {data.map((d) => {
        const disabled = typeof d.disabled === 'function' ? d.disabled(currentValue) : d.disabled;

        return (
          <Item key={d.value} disabled={disabled ?? !d.content} value={d.value} className="mt-2.5">
            <Header>{d.header}</Header>
            <Content>{d.content}</Content>
          </Item>
        );
      })}
    </RootComponent>
  );
}

Section.Root = Root;
Section.Item = Item;
Section.Header = Header;
Section.Content = Content;
Section.Trigger = Trigger;

export { Section };
